module.exports = __webpack_public_path__ + "img/@arrow_right.b00ed1ad.svg";